import {StyledBox, StyledErrorOutlineIcon, classes} from './DataRefetchOnErrorStyle'
import PropTypes from 'prop-types'
import Typography from '@mui/material/Typography'

function DataRefetchOnError({onTryAgain}) {
  return (
    <StyledBox>
      <StyledErrorOutlineIcon
        data-testid='data-refetch-on-error'
        classes={{colorPrimary: classes.icon.color}}
        color='primary'
      />
      <Typography variant='h6' className={classes.loadDataBoxAction}>
        There is an error while fetching the details. Please come back again later or{' '}
        <button
          onClick={onTryAgain}
          aria-label='Try again to fetch the details'
          style={{background: 'none', border: 'none', color: 'blue', textDecoration: 'underline', cursor: 'pointer'}}
        >
          try again
        </button>
      </Typography>
    </StyledBox>
  )
}

DataRefetchOnError.propTypes = {
  onTryAgain: PropTypes.func
}

export default DataRefetchOnError
